import { useCallback, useEffect, useRef } from 'react';

export const useThrottle = <T extends (...args: any[]) => void>(
  cb: T,
  limit: number
) => {
  const lastRun = useRef(0);
  const cbRef = useRef(cb);

  // Keep latest callback without breaking throttle state
  useEffect(() => {
    cbRef.current = cb;
  }, [cb]);

  return useCallback(
    (...args: Parameters<T>) => {
      const now = Date.now();

      if (now - lastRun.current >= limit) {
        cbRef.current(...args);
        lastRun.current = now;
      }
    },
    [limit]
  );
};
